import React from "react";
import { ListItem } from "material-ui/List";
import Avatar from "material-ui/Avatar";
import { grey400, darkBlack } from "material-ui/styles/colors";
import IconButton from "material-ui/IconButton";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";

//The following wrapper is used to avoid an error when using
//more than one icon inside the rightIconButton of a ListItem
const Wrapper = ({
  children,
  style,
  onKeyboardFocus,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
  onMouseUp,
  onClick,
  ...props
}) => {
  return (
    <div
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseUp={onMouseUp}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
};
const calculateQuantity = (showQuantity, ol) =>
  showQuantity === true && ol.quantity > 1
    ? <span key="quantity" style={{ color: "red" }}>
        {` ${ol.quantity} x `}
      </span>
    : "";

const calculateName = ol =>
  "[" + ol.variation.product.name + "]" + ol.variation.name;

const calculateCustomer = (name, team) =>
  name
    ? <span key="customer" style={{ float: "right" }}>
        {`⇨ ${name}(${team ? team : ""})`}
      </span>
    : "";

const calculatePrice = ol =>
  `${ol.quantity} x ${ol.unitPrice}€/ud  =  ${ol.quantity * ol.unitPrice}€`;

const calculateDescription = variationDetails => {
  const description = variationDetails
    .map(f => {
      const desc = `${f.name}: ${f.value}`;
      return desc;
    })
    .reduce((a, b) => a + " - " + b);
  return description;
};

const OrderLineListItem = ({
  orderId,
  orderLine,
  onClick,
  rightIcon,
  showPrice,
  showQuantity,
  customerName,
  customerTeam,
  moreOptions
}) => {
  let avatarImage;
  try {
    avatarImage = require("../../images/" + orderLine.variation.image);
  } catch (ex) {
    avatarImage = require("../../images/noimage.png");
  }

  const listItemStyle = {
    float: "right",
    height: "40px",
    width: "5px",
    margin: "0 5px",
    backgroundColor:
      orderLine.status === "DOING"
        ? "orange"
        : orderLine.status === "DONE" ? "lightgreen" : "lightgrey"
  };

  const iconButtonElement = (
    <IconButton touch={true} tooltip="more" tooltipPosition="bottom-left">
      <MoreVertIcon color={grey400} />
    </IconButton>
  );

  const countIcons =
    0 + (rightIcon !== undefined) + (moreOptions !== undefined);
  let iconWidth = 56;
  if (countIcons > 1) iconWidth += 40;
  const paddingRight = iconWidth + (showPrice ? 130 : 0); //this quantity should be calculated to take into account the estimated width of the price text
  const innerStyle = { paddingRight };

  const rightIconMenu = (
    <Wrapper>
      {showPrice
        ? <span
            style={{
              textAlign: "right",
              color: darkBlack,
              position: "absolute",
              right: iconWidth,
              top: 18,
              width: 130
            }}
          >
            {calculatePrice(orderLine)}
          </span>
        : ""}
      {rightIcon}
      {moreOptions
        ? <IconMenu iconButtonElement={iconButtonElement}>
            <MenuItem>Reply</MenuItem>
            <MenuItem>Forward</MenuItem>
            <MenuItem>Delete</MenuItem>
          </IconMenu>
        : ""}
    </Wrapper>
  );
  return (
    <ListItem
      hoverColor="rgba(0,0,0,0.1)"
      innerDivStyle={innerStyle}
      onClick={onClick}
      leftAvatar={
        <div>
          <Avatar src={avatarImage} />
          <div style={listItemStyle} />
        </div>
      }
      rightIconButton={rightIconMenu}
      primaryText={[
        calculateQuantity(showQuantity, orderLine),
        calculateName(orderLine)
      ]}
      secondaryText={
        <p>
          <span style={{ color: darkBlack }}>
            {calculateDescription(orderLine.variationDetails)}
          </span>
          {calculateCustomer(customerName, customerTeam)}
        </p>
      }
      secondaryTextLines={2}
    />
  );
};

export default OrderLineListItem;



// WEBPACK FOOTER //
// ./src/components/presentational/OrderLineListItem.js